const flexCollar = {
  displayField: 'internalName',
  name: 'Flex Collar',
  description: 'Flex collar component!',
  fields: [
    {
      id: 'internalName',
      name: 'Internal Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body Text',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'flexCollarSlides',
      name: 'Flex Collar Slides',
      type: 'Array',
      localized: false,
      required: true,
      validations: [ { size: { min: 1, max: null } } ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'flexCollarSlide' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  sys: {
    id: 'flexCollar',
    version: 20,
    updatedAt: '2023-08-02T21:58:26.990Z'
  }
};
export default flexCollar;